<template>
  <v-content>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      v-model="menu"
      transition="scale-transition"
      offset-y
      :nudge-right="40"
      min-width="290px"
      :return-value.sync="date"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          slot="activator"
          :label="label"
          :value="computedDateFormattedMomentjs"
          solo
          :flat="isFlat"
          readonly
          height="54"
          :rules="rules"
          prepend-inner-icon="date_range"
          v-on="on"
          :required="isRequired"
          :hide-details="hideDetails"
          :background-color="background"
        ></v-text-field>
      </template>
      <v-date-picker ref="picker" v-model="date" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="emitDate(date)">OK</v-btn>
      </v-date-picker>
    </v-menu>
  </v-content>
</template>

<script>
import moment from 'moment-timezone';

export default {
  data() {
    return {
      date: '',
      menu: false,
      rules: [],
    };
  },
  props: {
    label: {
      type: String,
      default: 'Data de Nascimento',
    },
    isFlat: {
      type: Boolean,
      default: true,
    },
    background: {
      type: String,
      default: '#F7F7F7',
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format('DD/MM/YYYY') : '';
    },
  },
  watch: {
    menu(val) {
      val
        && setTimeout(() => {
          this.$refs.picker.activePicker = 'YEAR';
        });
    },
  },
  mounted() {
    if (this.isRequired) {
      this.rules = [(v) => !!v || 'Esse campo é obrigatório'];
    }
  },
  methods: {
    emitDate(v) {
      this.$emit('date', v);
      this.$refs.menu.save(v);
    },
  },
};
</script>
